import { Component, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { Location } from '@angular/common'; 
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { AssetShipment } from '../../models/entities/asset-shipment';
import { AssetShipmentService } from '../../services/asset-shimpnent.service';


@Component({
    selector: 'asset-shipment-list-mobile',
    templateUrl: './asset-shipment-list-mobile.component.html',
    styleUrls: ['./asset-shipment-list-mobile.component.scss']
})


export class AssetShipmentListMobileComponent implements OnInit {

  assetShipments      : AssetShipment[]= []; 
  assetOrderCode      : string;
  newAssetShipment    : AssetShipment;
  direction           : string = undefined;
  assetTransferType   : string = undefined;

  selectedRow         : AssetShipment = null;
  listFields          = [];
  formFields          = [];
  title              : string = "Expéditions Client"

  constructor(
    protected assetShipmentService  : AssetShipmentService,
    protected toastr                 : ToastrService,
    protected router                 : Router,
    protected baseService            : BaseService,
    protected leanUtilsService       : LeanUtilsService,
    protected location               : Location,
    protected activatedRoute         : ActivatedRoute) {

  }

  ngOnInit(){

   this.listFields  = [  
    { prop: 'assetShipmentCode',    name: 'N° Exépdition' },
    { prop: 'description',          name: 'Description'},
    { prop: 'forecastDate',         name: 'Prévu',                   type: 'date' },
  ]

  this.formFields = [  
     { prop: 'assetShipmentCode',      name: 'N° Exépdition'                 },
     { prop: 'description',          name: 'Description'},
     { prop: 'forecastDate',           name: 'Prévu',           type: 'date' },
     { prop: 'progressLevel',          name: 'Stade'                         },
   ]
    
   let assetShipmentCode : string;
   let branchCode        : string = null;
   let progressLevels     : boolean[] = [true, true, false];
  this.assetShipmentService.assetShipmentsGet(assetShipmentCode, branchCode, progressLevels).then(result => {
    this.assetShipments = result;
  })

  }


selectRow(assetShipment : AssetShipment){
  this.assetShipmentService.assetShipmentGet(assetShipment.assetShipmentCode).then(assetShipment => {
      this.selectedRow = assetShipment;
  });
}

  returnBack(){
    this.location.back();
  }
}
